import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie9';
import 'core-js/modules/es6.string.starts-with';
import 'core-js/modules/es6.symbol';
import './index.css';
import './i18n';
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js